var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InputText,{ref:"inputTextRef",attrs:{"value":_setup.localValue,"label":_setup.documentLabel,"name":_setup.validationName,"rules":_setup.validationRules,"disabled":!_vm.type || _vm.disabled,"maxlength":_setup.maxlength},on:{"input":_setup.onInput,"change":_setup.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }